import React from 'react';
import { VStack, HStack, Box } from '@chakra-ui/react';
import { Outlet } from 'react-router';
import Header from '../components/layout/Header';
import Sidenav from '../components/layout/Sidenav';
import PageContentCard from '@/components/layout/PageContentCard';

const MainLayout = () => {
    return (
        <VStack gap={0}>
            <Header />
            <HStack w='100%' gap={0} bg='bg.muted'>
                <Sidenav />
                <PageContentCard>
                    <Outlet />
                </PageContentCard>
            </HStack>
        </VStack>
    )
}

export default MainLayout